/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import { Dropdown } from "react-bootstrap";
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import { DropdownCustomToggler, DropdownMenu2 } from "../../dropdowns";
import { useHtmlClassService } from "../../../layout";
import { HorizontalBar, Line, Scatter } from "react-chartjs-2";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

export function MixedWidget4({
  series,
  categories,
  currency,
  headLine,
  invoiceStatistics,
  topRightOverall,
  topRightOverallValue,

  topRight1OverallHeadLine,
  topRight1OverallValue,

  topleftOverall,
  topleftOverallValue,
  botleftOverall,
  botleftOverallValue,
  botrightOverall,
  botrightOverallValue,

  botrightExtra,
  botrightExtraValue,
  className,
  chartColor = "success",
}) {
  const [data, setData] = useState(null);
  const [options, setOptions] = useState(undefined);

  const [scatterData, setScatterData] = useState(undefined);
  const [scatterOptions, setScatterOptions] = useState(undefined);

  const [lineData, setLineData] = useState(null);
  const [lineOptions, setLineOptions] = useState(undefined);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray500"
      ),
      colorsGrayGray200: objectPath.get(
        uiService.config,
        "js.colors.gray.gray200"
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.${chartColor}`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.${chartColor}`
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService, chartColor]);

  useEffect(() => {
    if (series && series[0] && series[0].name) {
      let debtAmount = [];
      let debtTitle = series[0].name;
      let paymentDelayAmount = [];
      let delayTitle = series[1].name;

      categories.forEach((element, i) => {
        debtAmount.push(series[0].data[i] - series[1].data[i]);
        // paymentDelayAmount.push({ label: element, y: (series[1].data[i] / series[0].data[i]) * 100 })
      });

      const data = {
        labels: categories.map((c) =>
          c.length > 20 ? `${c.substring(0, 20)}..` : c
        ),
        datasets: [
          {
            label: delayTitle,
            data: series[1].data,
            backgroundColor: "rgb(255, 31, 78)",
          },
          {
            label: debtTitle,
            data: debtAmount,
            backgroundColor: "rgb(54, 162, 235)",
          },
        ],
      };

      const options = {
        tooltips: {
          callbacks: {
            // label: function (tooltipItem, data) {
            //   if (tooltipItem.datasetIndex === 0) {
            //     let delayDebt = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
            //     return `${delayTitle}: ${delayDebt}`;
            //   }

            //   let totalDebt = data.datasets[1].data[tooltipItem.index] + data.datasets[0].data[tooltipItem.index]

            //   return `${debtTitle}: ${totalDebt}`;
            // },
            title: function(tooltipItem, data) {
              return categories[tooltipItem[0].index];
            },
          },
        },
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
            },
          ],
        },
      };

      setOptions(options);
      setData(data);



    }


  }, [series]);

  useEffect(() => {
    if (invoiceStatistics && invoiceStatistics.xAxesLabels.length > 0) {
      let lineDataa = {
        labels: invoiceStatistics.xAxesLabels,
        datasets: [
          {
            label: "Total past due amount",
            data: invoiceStatistics.overdueDebtData,
            fill: false,
            backgroundColor: "rgb(255, 99, 132)",
            borderColor: "rgba(255, 31, 78, 0.7)",
          },
          {
            label: "Total receivables",
            data: invoiceStatistics.debtData,
            fill: false,
            backgroundColor: "rgb(54, 162, 235)",
            borderColor: "rgba(54, 162, 235, 0.7)",
          },
        ],
      };

      let lineOptionss = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };

      setLineData(lineDataa);
      setLineOptions(lineOptionss);

      const scatterData = {
        datasets: [
          {
            label: 'Past due customers',
            data: invoiceStatistics.scatterData,
            backgroundColor: 'rgba(255, 99, 132, 1)',
          },
        ],
      }

      const scatterOptions = {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return `amount: ${tooltipItem.yLabel}, days: ${tooltipItem.xLabel}`;
            },
            title: function (tooltipItem, data) {
              return data.datasets[0].data[tooltipItem[0].index].customerName;
            },
          },
        },

        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Days',
              },
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Amount',
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      }

      setScatterData(scatterData)
      setScatterOptions(scatterOptions)

    }
  }, [invoiceStatistics])

  return (
    <>
      {/* begin::Tiles Widget 1 */}
      <div className={`card card-custom bg-white ${className}`}>
        {/* <div className="pl-10 pt-10" >
          <h3 className="card-title font-weight-bolder">
            {headLine}
          </h3>
        </div> */}

        {scatterData && (
          <div style={{ padding: "0px 20%", margin: "5% 0px 0px 0px" }}>
            <Scatter data={scatterData} options={scatterOptions} />
          </div>
        )}

        {lineData && (
          <div style={{ padding: "0px 20%", margin: "5% 0px" }}>
            <Line data={lineData} options={lineOptions} />
          </div>
        )}
        {options && (
          <div style={{ padding: "0px 20%" }}>
            <HorizontalBar data={data} options={options} />
          </div>
        )}
        {/* begin::Header */}
        {/* <div className="card-header border-0 pt-5 flex-column"> */}

        {/* <HorizontalBar style={{ padding: '20%' }} options={{
            maintainAspectRatio: false,
          }}
            data={data} options={options} /> */}
        {/* <div className="card-toolbar">
            <Dropdown className="dropdown-inline" alignRight>
              <Dropdown.Toggle
                className="btn btn-text-white btn-hover-white btn-sm btn-icon border-0"
                variant="transparent"
                id="dropdown-toggle-top"
                as={DropdownCustomToggler}
              >
                <i className="ki ki-bold-more-hor" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <DropdownMenu2 />
              </Dropdown.Menu>
            </Dropdown>
          </div> */}
        {/* </div> */}
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body d-flex flex-column p-0">
          {/* begin::Chart */}
          {/* <div
            id="kt_mixed_widget_4_chart"
            data-color={chartColor}
            style={{ height: "200px", minHeight: "200px", paddingTop: 50 }}
          /> */}
          {/* end::Chart */}

          {/* begin::Stats */}
          <div className="card-spacer bg-white card-rounded flex-grow-1">
            {/* begin::Row */}
            <div className="row m-0">
              <div className="col px-8 py-6 mr-8">
                <div className="font-size-sm text-muted font-weight-bold">
                  {topleftOverall}
                </div>
                <div className="font-size-h4 font-weight-bolder">
                  {topleftOverallValue}
                </div>
              </div>
              <div className="col px-8 py-6">
                <div className="font-size-sm text-muted font-weight-bold">
                  {topRightOverall}
                </div>
                <div className="font-size-h4 font-weight-bolder">
                  {topRightOverallValue}
                </div>
              </div>
              <div className="col px-8 py-6">
                <div className="font-size-sm text-muted font-weight-bold">
                  {topRight1OverallHeadLine}
                </div>
                <div className="font-size-h4 font-weight-bolder">
                  {topRight1OverallValue}
                </div>
              </div>
            </div>
            {/* end::Row */}
            {/* begin::Row */}
            <div className="row m-0">
              <div className="col px-8 py-6 mr-8">
                <div className="font-size-sm text-muted font-weight-bold">
                  {botleftOverall}
                </div>
                <div
                  className="font-size-h4 font-weight-bolder mt-3"
                  style={{ width: "30%", height: "30%" }}
                >
                  <CircularProgressbar
                    value={botleftOverallValue}
                    text={`${botleftOverallValue}%`}
                    styles={buildStyles({
                      textSize: "1em",
                      textColor: "red",
                      pathColor: "rgb(255, 31, 78)",
                    })}
                  />
                </div>
              </div>
              {/* <div className="col px-8 py-6"> */}
              {/* <div className="font-size-sm text-muted font-weight-bold">
                  {botrightOverall}
                </div>
                <div className="font-size-h4 font-weight-bolder">
                  {botrightOverallValue}
                </div> */}
              {/* </div> */}
              <div className="col px-8 py-6" style={{ padding: "10%" }}>
                <div className="font-size-sm text-muted font-weight-bold">
                  {botrightExtra}
                </div>
                <div
                  className="font-size-h4 font-weight-bolder mt-3"
                  style={{ width: "30%", height: "30%" }}
                >
                  <CircularProgressbar
                    value={botrightExtraValue}
                    text={`${botrightExtraValue}%`}
                    styles={buildStyles({
                      textSize: "1em",
                      textColor: "red",
                      pathColor: "rgb(255, 31, 78)",
                    })}
                  />
                </div>
              </div>
              <div className="col px-8 py-6">
                {/* <div className="font-size-sm text-muted font-weight-bold">
                  {botrightOverall}
                </div>
                <div className="font-size-h4 font-weight-bolder">
                  {botrightOverallValue}
                </div> */}
              </div>
            </div>
            {/* end::Row */}
          </div>
          {/* end::Stats */}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Tiles Widget 1 */}
    </>
  );
}
